import { dateAndTimeConverter, getYearsArray } from "./Constants";
import downloadGifDark from "../../Assets/downloadDark.gif";
import downloadGifLight from "../../Assets/downloadLight.gif";

export const defaultReportFilter = {
  month: [new Date().toLocaleString("default", { month: "long" })],
  year: [+new Date().getFullYear()],
  reportType: []
};

export const reportsTableHeadings = [
  {
    title: "SI.No",
    width: "70px",
    textAlign: "left"
  },
  {
    title: "NAME",
    width: "400px",
    textAlign: "left"
  },
  {
    title: "REPORT TYPE",
    width: "300px",
    textAlign: "left"
  },
  {
    title: "PERIOD",
    width: "300px",
    textAlign: "left"
  },
  {
    title: "UPLOADED BY",
    width: "200px",
    textAlign: "left",
    textTransform: "lowercase"
  },
  {
    title: "UPLOADED AT",
    width: "200px",
    textAlign: "right"
  }
];

export const reportsTableField = (data, type) => {
  switch (data) {
    case "SI.No":
      return "serialNo";
    case "Name":
      return "name";
    case "REPORT TYPE":
      return "type";
    case "PERIOD":
      return type === "sort" ? "info.period.from" : "period";
    case "UPLOADED BY":
      return type === "sort" ? "uploadedBy.name" : "uploadedBy";
    case "UPLOADED AT":
      return "createdAt";
    default:
      return data?.toLowerCase();
  }
};

export const reportsFilterData = () => [
  {
    key: "month",
    title: "MONTH",
    multiple: false,
    options: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  {
    key: "year",
    title: "YEAR",
    multiple: false,
    options: getYearsArray(2022, new Date().getFullYear())
  },
  {
    key: "reportType",
    title: "REPORT TYPE",
    multiple: true,
    options: [
      "Payslip",
      "Custom",
      "Provident fund",
      "Employees state insurance",
      "KPI Summary"
    ]
  }
];

export function convertToTableData(data, loadingDocumentId) {
  const tableData = [];

  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    const transformedItem = {
      ...item,
      serialNo: i + 1,
      documentId: item?.documentId,
      period: `${dateAndTimeConverter(
        item?.info?.period?.from,
        "secondDate"
      )} - ${dateAndTimeConverter(item?.info?.period?.to, "secondDate")}`,
      fileName: item?.name,
      name: (
        <div className=" display-flex flex-justify-content-space-between">
          <div>{item?.name}</div>
          {loadingDocumentId === item?.documentId ? (
            <img
              height={16}
              width={16}
              src={
                getComputedStyle(document.documentElement).getPropertyValue(
                  "--primaryColor"
                ) === "#F3F3F3"
                  ? downloadGifLight
                  : downloadGifDark
              }
              alt="downloading"
            />
          ) : (
            <></>
          )}
        </div>
      ),
      type: item?.type,
      uploadedBy: `${item?.uploadedBy?.name || "N/A"}, ${
        item?.uploadedBy?.email
      }`,
      createdAt: `${dateAndTimeConverter(
        item?.createdAt,
        "Time"
      )}, ${dateAndTimeConverter(item?.createdAt, "thirdDate")}`
    };
    tableData.push(transformedItem);
  }
  return tableData;
}
